var SessionStorageHelper = {
  setItem: function setItem(key, item) {
    try {
      var sessionStorage = typeof window !== 'undefined' && window.sessionStorage;
      if (sessionStorage) {
        sessionStorage.setItem(key, item);
      }
    } catch (e) {}
  },
  getItem: function getItem(key) {
    try {
      if (typeof window !== 'undefined' && window.sessionStorage) {
        return window.sessionStorage.getItem(key);
      }
      return null;
    } catch (e) {
      return null;
    }
  },
  removeItem: function removeItem(key) {
    try {
      var sessionStorage = typeof window !== 'undefined' && window.sessionStorage;
      if (sessionStorage) {
        sessionStorage.removeItem(key);
      }
    } catch (e) {}
  }
};
export default SessionStorageHelper;